<template>
    <v-dialog
            v-model="show"
            scrollable
            width="500"
            content-class="rounded-lg"
    >
        <v-card>
            <v-toolbar height="52" flat outlined>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-4">
                <v-form ref="form" v-model="valid">
                    <v-select
                            v-model="carryInItem.visitorId"
                            :rules="[ rules.name ]"
                            :items="visitors"
                            item-text="visitorName"
                            item-value="visitorId"
                            required
                            label="방문자"
                            :readonly="readonly"
                    ></v-select>

                    <!-- 반입 물품 정보 -->
                    <template v-for="item in availableFieldList">
                        <v-textarea
                            v-if="item.type === 'multiline-text'"
                            :key="item.column"
                            v-model="carryInItem[item.column]"
                            :rules="item.rules"
                            :counter="readonly ? null : item.maxlength"
                            :maxlength="readonly ? null : item.maxlength"
                            :required="item.required"
                            :label="item.label"
                            :hint="readonly ? null : item.hint"
                            :readonly="readonly"
                        ></v-textarea>
                        <v-text-field
                            v-else
                            :key="item.column"
                            v-model="carryInItem[item.column]"
                            :rules="item.rules"
                            :counter="readonly ? null : item.maxlength"
                            :maxlength="readonly ? null : item.maxlength"
                            :required="item.required"
                            :label="item.label"
                            :hint="readonly ? null : item.hint"
                            :readonly="readonly"
                        ></v-text-field>
                    </template>
                </v-form>
            </v-card-text>

            <v-footer outlined
                      height="50"
                      color="#fff"
                      class="px-2 justify-center"
            >
                <v-row justify="end" align="center" no-gutters>
                    <v-col cols="auto">
                        <template v-if="!readonly">
                            <v-btn
                                depressed
                                class="secondary-btn"
                                @click="cancel()"
                            >
                                취소
                            </v-btn>
                            <v-btn
                                depressed
                                width="100"
                                class="ml-2 primary-btn"
                                :disabled="!valid"
                                @click="submit()"
                            >
                                확인
                            </v-btn>
                        </template>
                        <template v-else>
                            <v-btn
                                depressed
                                width="100"
                                class="secondary-btn"
                                @click="cancel()"
                            >
                                닫기
                            </v-btn>
                        </template>
                    </v-col>
                </v-row>
            </v-footer>
        </v-card>
    </v-dialog>
</template>

<script>
import ImportItemHelper from "@/service/importItemHelper";
import utilService from "@/service/utilService";

export default {
    name: 'CarryInDialog',

    props: {
        value: {
            type: Boolean,
            required: true,
        },

        targetItem: {
            type: Object,
        },
        visitors: {
            type: Array,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        show: false,
        valid: false,
        title: null,

        defaultData: {
            importId: null,
            visitorId: null,
            importType: null,
            manufacturer: null,
            model: null,
            serial: null,
            reason: null,
        },

        carryInItem: {
            importId: null,
            visitorId: null,
            importType: null,
            manufacturer: null,
            model: null,
            serial: null,
            reason: null,
        },

        availableFieldList: [],

        rules: {
            name: v => !!v || '방문자를 선택하세요',
            importType: v => !!v || '물품종류를 입력하세요',
            manufacturer: v => !!v || '제조사를 입력하세요',
            model: v => !!v || '모델명을 입력하세요',
            serial: v => !!v || '시리얼번호를 입력하세요',
            reason: v => !!v || '사유를 입력하세요',
        },
    }),

    computed: {
        /**
         * 백오피스 반입물품 입력 항목 설정을 가져온다.
         *
         * @return [] 반입물품 입력 가능한 필드 정보
         */
        fieldConfig() {
            return ImportItemHelper.parseImportItemColumnsConfig(this.$code.get('service.config.import_item_columns'))
        }
    },

    watch: {
        show(val) {
            this.$emit('input', val);
        },

        value(val) {
            this.show = val;
            if (val) {
                if (this.targetItem) {
                    this.carryInItem = {...this.targetItem}
                    this.title = '반입물품 / 전자기기 수정';
                } else {
                    this.carryInItem.importId = utilService.uuid();
                    this.title = '반입물품 / 전자기기 등록';
                }
            } else {
                this.close();
            }
        }
    },

    created() {
        this.show = this.value;
        this.availableFieldList = this.fieldConfig
            .filter(e => e.enable)
            .map(e => {
                return {
                    rules: [ this.rules[e.column] ],
                    ...e,
                }
            });
    },

    methods: {
        _reset() {
            Object.assign(this.carryInItem, this.defaultData);

            // Form validation initialize
            if (this.$refs.form) this.$refs.form.reset();
        },

        submit() {
            Object.keys(this.carryInItem).forEach(key => {
                const field = this.fieldConfig.find(e => e.column === key);
                const column = field ? field.column : null;
                const defaultValue = field ? field.default : null;
                if (column in this.carryInItem && !this.carryInItem[column]) {
                    this.carryInItem[column] = defaultValue;
                }
            })

            this.$emit('save', {...this.carryInItem});
            this.carryInItem = this.defaultData;
            this.close();
        },

        cancel() {
            this.close();
        },

        close() {
            this._reset();
            this.$emit('close');
        },
    }

}
</script>

<style scoped>

</style>